<template>
  <v-row>

    <v-col cols="12" class="pa-3" v-if="!loading">
      <showConvocationForm v-if="convocation_form.version=='v1'" :data="convocation_form" />
      <showConvocationFormV2 v-if="convocation_form.version=='v2'" :data="convocation_form" />
      <showConvocationFormV3 v-if="convocation_form.version=='v3'" :data="convocation_form" />
    </v-col>

    <v-col cols="12" class="d-sm-flex pt-8">
      <v-btn
        :block="$vuetify.breakpoint.xsOnly"
        class="mr-auto mt-2"
        depressed
        color="primary"
        :to="{ name: 'showEntrepreneurshipOrganizer' }">
        <v-icon left>
          mdi-arrow-left
        </v-icon>
        Volver
      </v-btn>
    </v-col>

    <v-dialog
      v-model="loading"
      overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          <label>Cargando...</label>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
  import axios from 'axios'
  import download from 'downloadjs'
  const VUE_URL_API = process.env.VUE_APP_URL_API
  import showConvocationForm from '@/components/convocation_form/showConvocationForm.vue'
  import showConvocationFormV2 from '@/components/convocation_form/showConvocationFormV2.vue'
  import showConvocationFormV3 from '@/components/convocation_form/showConvocationFormV3.vue'

  export default {
    name: 'showConvocationFormOrganizer',
    components: {
      showConvocationForm,
      showConvocationFormV2,
      showConvocationFormV3
    },
    data: () => ({
      loading:true,
      loading_download: false,
      edition_id:null,
      entrepreneurship_id:null,

      show:false,
      entrepreneurship:[],
      convocation_form: [],

      attrs: {
        boilerplate: false,
      },
    }),

    methods:{
      async getConvocationFormOrganizer(){
        await axios.get('organizer/entrepreneurships/'+this.entrepreneurship_id+'/convocation-form').then(response =>{
          this.convocation_form = response.data.data.convocation_form
          this.loading=false
          this.show = true
        }).catch(error => {
          console.log(error)
        })
      },

      async downloadPDF(){
        this.loading_download=true

        this.url = VUE_URL_API + '/admin/edition/'+this.edition_id+'/entrepreneurships/'+this.entrepreneurship_id+'/generate-pdf'
        await axios.get(
          this.url, 
          {responseType: 'blob'}
        ).then((response) => {
          //window.open(URL.createObjectURL(response.data));
          const content = response.headers['content-type'];
          download(response.data, this.entrepreneurship.title , content)
          this.loading_download=false
        })
      },
    },

    created(){
      this.edition_id = this.$route.params.edition_id;
      this.entrepreneurship_id = this.$route.params.entrepreneurship_id;
      this.getConvocationFormOrganizer()
      },
  }
</script>